export default "__VITE_ASSET__4AEae78i__"